<template>
    <article>
        <p>
            An SLO (Service Level Objective) is a specific goal that defines how well a service should perform,
            such as its uptime or response time. It sets the standard for reliability or performance that a service needs to meet to keep users happy.
        </p>

        <p>
            The most common SLOs focus on availability and latency:
        </p>

        <ul>
            <li>
                Availability SLO: This tracks how often a service is available to users.
                For example, an SLO might require that 99.9% of all requests are successful.
            </li>
            <li>
                Latency SLO: This measures how fast a service responds.
                An example SLO might state that 99% of requests should be completed in under 500 milliseconds.
            </li>
        </ul>

        <p>
            Coroot uses eBPF to automatically gather performance data for each service.
            It also comes with preset SLOs that you can easily adjust, so it can start monitoring your services right after installation.
        </p>

        <p>
            To avoid violating SLOs, Coroot alerts your team when the error budget is being consumed too quickly.
            It uses multi-window burn rate thresholds to trigger alerts:
        </p>

        <BurnRateThresholds class="mb-4" />

        <p>
            An incident will be triggered if the burn rate exceeds the threshold in both the long and short windows.
            The short window helps ensure the error budget is still being actively used.
        </p>

        <p>
            To prevent false positive alerts, Coroot only calculates the burn rate if at least half of the window contains valid data.
            This is especially useful for services with low traffic.
        </p>

        <v-alert color="grey" outlined icon="mdi-book-open-variant">
            The detailed explanation of SLO-based alerting you can find in
            <a href="https://sre.google/workbook/alerting-on-slos/" target="_blank">The SRE Workbook</a>.
        </v-alert>

        <p>
            When an application significantly violates its SLOs, Coroot triggers an incident and notifies the team through the configured integrations:
        </p>

        <ul>
            <li><router-link :to="{params: {item: 'slack'}}">Slack</router-link></li>
            <li><router-link :to="{params: {item: 'teams'}}">Microsoft Teams</router-link></li>
            <li><router-link :to="{params: {item: 'pagerduty'}}">Pagerduty</router-link></li>
            <li><router-link :to="{params: {item: 'opsgenie'}}">OpsGenie</router-link></li>
            <li><router-link :to="{params: {item: 'webhook'}}">Webhook</router-link></li>
        </ul>

    </article>
</template>

<script>

import BurnRateThresholds from "@/components/BurnRateThresholds.vue";

export default {
    components: {BurnRateThresholds}
}
</script>

<style scoped>
</style>
